<template lang="pug">
dynamic-filter-picker(
    title="Custom Filter"
)
    div(slot="body")
        div(v-if="multiple_product")
            product-dynamic-filter
        div(v-else-if="voided_type")
            voided-type-dynamic-filter
        div(v-else-if="product_category")
            product-category-dynamic-filter
        div(v-else-if="transaction_type")
            transaction-dynamic-filter
        div(v-else-if="label")
            label-dynamic-filter(:payment="payment" :hide_till="hide_till")
        div(v-else-if="subsidy_reimbursement")
            subsidy-reimbursement-dynamic-filter
        div(v-else-if="tng_subsidy_reimbursement")
            subsidy-reimbursement-dynamic-filter(
                storeModule="tngSubsidyReimbursementReport"
                :hidePayment="true"
            )
        div(v-else)
            till-dynamic-filter(
                :till_columns="till_columns"
                :hide_till_closure="hide_till_closure"
                :show_attendant_cashier="show_attendant_cashier"
                :ignore_strategy="ignore_strategy"
            )
</template>

<script>
import dynamicFilterPicker from '@js/components/filter/dynamic-filter-picker';
import productDynamicFilter from './product/product-dynamic-filter';
import tillDynamicFilter from '../till-filter/till-dynamic-filter';
import voidedTypeDynamicFilter from '../voided-type-filter/voided-type-dynamic-filter';
import transactionDynamicFilter from '../../franchise_component/transaction/filters/transaction-dynamic-filter';
import labelDynamicFilter from './label/label-dynamic-filter';
import productCategoryDynamicFilter from './profit/product-category-dynamic-filter';
import subsidyReimbursementDynamicFilter from './subsidy-reimbursement/subsidy-reimbursement-dynamic-filter';

export default {
    components: {
        productDynamicFilter,
        dynamicFilterPicker,
        tillDynamicFilter,
        voidedTypeDynamicFilter,
        transactionDynamicFilter,
        labelDynamicFilter,
        productCategoryDynamicFilter,
        subsidyReimbursementDynamicFilter,
    },

    props: {
        multiple_product: {
            type: Boolean | Number,
            default: false,
        },

        voided_type: {
            type: Boolean | Number,
            default: false,
        },

        till_columns: {
            type: Object | Array,
            default: () => null,
        },

        transaction_type: {
            type: Boolean | Number,
            default: false,
        },

        label: {
            type: Boolean | Number,
            default: false,
        },

        payment: {
            type: Boolean | Number,
            default: false,
        },

        hide_till: {
            type: Boolean | Number,
            default: false,
        },

        hide_till_closure: {
            type: Boolean | Number,
            default: false,
        },

        show_attendant_cashier: {
            type: Boolean | Number,
            default: false,
        },

        product_category: {
            type: Boolean | Number,
            default: false,
        },

        ignore_strategy: {
            type: Boolean | Number,
            default: false,
        },

        hide_site: {
            type: Boolean | Number,
            default: false,
        },

        subsidy_reimbursement: {
            type: Boolean | Number,
            default: false,
        },

        tng_subsidy_reimbursement: {
            type: Boolean | Number,
            default: false,
        },
    },
};
</script>
